import { useCallback, useState } from 'react';
import links from 'utils/links';
import { useFetchOld, muteErrorAndResult } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { selectIsGBUser } from 'reducers/selectors';
import { getHelpArticlesCall } from '../actions';
const MIN_SEARCH_TERM_LENGTH = 1;
export const useHelpArticlesSearch = () => {
    const [helpArticles, setHelpArticles] = useState([]);
    const [, , isFetching, fetch] = useFetchOld(muteErrorAndResult);
    const isGBUser = useAppSelector(selectIsGBUser);
    const locale = isGBUser ? 'en' : 'en-us';
    const searchByTitle = useCallback(async (searchTitle) => {
        if (searchTitle.length < MIN_SEARCH_TERM_LENGTH) {
            setHelpArticles([]);
            return;
        }
        const articles = await fetch(getHelpArticlesCall({ locale, search_title: searchTitle }));
        setHelpArticles(articles ?? []);
    }, [locale]);
    const openHelpArticle = useCallback((url) => {
        links.openLink(url);
    }, []);
    return {
        searchByTitle,
        helpArticles,
        isFetching,
        openHelpArticle,
    };
};
